

export class CompanyLicenseDetailsStatusInput implements ICompanyLicenseDetailsStatusInput {
    /** The auto-generated id of the company license details master */
    companyLicenseDetailsId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ICompanyLicenseDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyLicenseDetailsId = _data["companyLicenseDetailsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyLicenseDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLicenseDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyLicenseDetailsId"] = this.companyLicenseDetailsId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICompanyLicenseDetailsStatusInput {
    /** The auto-generated id of the company license details master */
    companyLicenseDetailsId: number;
    /** The updated status */
    status: number;
}

